import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=21e0555f&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=js"
export * from "./eventList.vue?vue&type=script&lang=js"
import style0 from "./eventList.vue?vue&type=style&index=0&id=21e0555f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0555f",
  null
  
)

export default component.exports